import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=2db310af&scoped=true&"
import script from "./NotFound404.vue?vue&type=script&lang=js&"
export * from "./NotFound404.vue?vue&type=script&lang=js&"
import style0 from "./NotFound404.vue?vue&type=style&index=0&id=2db310af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db310af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VContent } from 'vuetify/lib/components/VContent';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VAppBarNavIcon,VContent,VLayout,VToolbarTitle})
